<template>
	<div>
		<section>
			<el-form :model="formInline" :inline="true" label-width="80px">
				<el-form-item label="姓名">
					<el-input v-model="formInline.name" placeholder="输入姓名" style="width: 120px;" clearable=""></el-input>
				</el-form-item>
				<el-form-item label="电话">
					<el-input v-model="formInline.phone" placeholder="输入电话" style="width: 120px;" clearable=""></el-input>
				</el-form-item>
				<el-form-item label="申请时间">
					<el-col :span="11">
						<el-date-picker type="date" placeholder="选择开始日期" v-model="formInline.startTime" style="width: 100%;" value-format="timestamp"
						 :picker-options="beginDate"></el-date-picker>
					</el-col>
					<el-col class="line" :span="2" style="text-align: center;">—</el-col>
					<el-col :span="11">
						<el-date-picker type="date" placeholder="选择结束日期" v-model="formInline.endTime" style="width: 100%;" value-format="timestamp"
						 :picker-options="endDate"></el-date-picker>
					</el-col>
				</el-form-item>
				<el-form-item>
					<el-button @click="handleQuery">搜索</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="name" label="姓名" align="center">
				</el-table-column>
				<el-table-column prop="phone" label="电话" align="center">
				</el-table-column>
				<el-table-column prop="createTime" label="申请时间" align="center">
				</el-table-column>
				<el-table-column prop="type" label="状态" align="center">
				</el-table-column>
				<el-table-column prop="dealUserName" label="处理人" align="center">
				</el-table-column>
				<el-table-column prop="email" label="邮箱" align="center">
				</el-table-column>
				<el-table-column prop="updateTime" label="处理时间" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.updateTime">{{scope.row.updateTime.split("T")[0]}}</span>
						<span v-else>无</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="{row}">
						<el-button v-if="row.type=='未处理'" size="mini" @click="checkClick(row)">审批</el-button>
						<el-button v-else size="mini" disabled>已审批</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background :page-size="pageSize" layout="total, prev, pager, next,sizes" @current-change="handleCurrentChange"
			 :total="totalNum" @size-change="handleSizeChange" />
		</section>

		<el-dialog title="查看文件" :visible.sync="dialogVisible" width="30%">
			<p v-for="(item,index) in fileList" @click="downloadFile(item)">{{item.name}}&nbsp;&nbsp;&nbsp; <span>下载查看</span></p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleForgetPassword('拒绝')">拒绝</el-button>
				<el-button type="primary" @click="handleForgetPassword('同意')">同 意</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import downloadFile from '../../assets/js/downloadFile.js'

	export default {
		data() {
			return {
				// 保证开始时间小于结束时间
				beginDate: {
					disabledDate: (time) => {
						if (this.formInline.endTime) {
							return (
								time >= this.formInline.endTime
							)
						}
					}
				},
				// 保证结束时间大于开始时间
				endDate: {
					disabledDate: (time) => {
						// console.log("end",time);
						if (this.formInline.startTime) {
							return time <= this.formInline.startTime
						}
					}
				},
				email:"",//点击审批时，当前行的邮箱
				currentPage: 1,
				pageSize: 10,
				totalNum: 0,
				tableData: [],
				formInline: {
					name: null,
					phone: null,
					startTime: null,
					endTime: null,
				},
				dialogVisible: false,

				fileList: [],
				id: null,
				phone: null,
			}
		},

		mounted() {
			this.getAll();
		},
		methods: {
			getAll() {
				this.$http.post("/api/user/findForgetPassword", { ...this.formInline,
					currentPage: this.currentPage,
					pageSize: this.pageSize,
				}).then(res => {
					console.log(res);
					this.tableData = res.data.data.items;
					this.totalNum = res.data.data.totalNum;
					this.tableData.forEach(item => {
						item.createTime = item.createTime.split("T")[0];
					})
				})
			},
			checkClick(row) {
				this.dialogVisible = true;
				this.fileList = row.fileRes;
				this.id = row.id;
				this.phone = row.phone;
				this.email = row.email
			},
			// 下载文件
			downloadFile(file) {
				downloadFile(file);
			},

			// 搜索
			handleQuery() {
				if (this.formInline.startTime == null && this.formInline.endTime != null) {
					this.$message.info("开始日期必选")
				}
				if (this.formInline.startTime != null && this.formInline.endTime == null) {
					this.$message.info("结束日期必选")
				}
				this.getAll();
			},

			// 分页
			// 当前页
			handleCurrentChange(val) {
				console.log(val);
				this.currentPage = val;
				this.getAll();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAll();
			},

			// 处理忘记密码
			handleForgetPassword(type) {
				this.$http.post("/api/user/handleForgetPassword", {
					type: type,
					id: this.id,
					phone: this.phone,
					email:this.email
				}).then(res => {
					console.log(res);
					this.getAll();
					this.dialogVisible = false;
				})
			},
		},
	}
</script>

<style scoped="scoped">
	section {
		margin-top: 60px;
	}

	p {
		margin: 10px 0;
	}

	p:hover,
	span:hover {
		cursor: pointer;
	}
</style>
